
import { useCallback } from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import AdminPageContainer from "../../../components/admin/page-container";
import useAdminLogin from "../../../modules/admin/hooks/use-admin-login";

type Props = {}

const Container = styled.div`
    .form {
        display: flex;
        justify-content: center;
        align-items: stretch;
    }

    .row {
        margin: 1em 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    input {
        padding: .5em;
    }

    .error {
        color: red;
    }
`;

const AdminLoginPage: React.FC<Props> = () => {
    const { adminLogin, isLoading, error } = useAdminLogin();

    const { register, handleSubmit } = useForm();

    const onSubmit = useCallback((data) => {
        adminLogin(data);
    }, [adminLogin]);

    return <AdminPageContainer>
        <Container>
            <h2>Logowanie</h2>
            <div className="form">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <input type="text" placeholder="hasło..." {...register('password')} />
                    </div>
                    {!isLoading && <div className="row">
                        <button>Zaloguj</button>
                    </div>}

                    {error && <div className="row">
                        <p className="error">
                            Błąd logowania
                        </p>
                    </div>
                    }
                </form>
            </div>
        </Container>
    </AdminPageContainer>
}

export default AdminLoginPage;
